/**
 * A href is a same-origin in-app path only if it is a leading-slash
 * absolute path. Protocol-relative URLs (`//evil.example/x`) also start
 * with `/` and must be rejected: they resolve off-site.
 */
export function isSiteRelativeHref(href: string): boolean {
  return href.startsWith('/') && !href.startsWith('//');
}
